import React, { useState } from "react";

import { SearchIcon } from "@/Components/Icons/SearchIcon";

import ActionIcons from "../ActionIcons";

/**
 * Function component for table search input.
 *
 * @param {object} val - the value of the search input
 * @param {function} handleChange - the function to handle input change
 * @param {boolean} isLoading - indicates if the input should be disabled
 * @return {JSX} the search input JSX
 */
const TableSearch = ({ val, handleChange, cls = false, isLoading }) => {
  const [inputFocused, setInputFocused] = useState(false);
  return (
    <div
      className={`TableSearch_Wrapper xl:w-full ${cls ? "md:max-w-full" : "md:max-w-[350px]"} max-md:max-w-full`}
    >
      <div
        className={`relative flex h-[40px] w-full items-center justify-start gap-[10px] rounded-lg border bg-grey px-2 transition-[border] duration-200 ease-linear xl:px-[16px] ${inputFocused ? "border-primary" : "border-grey"}`}
      >
        <SearchIcon cls="min-w-[24px]" />
        <input
          type="text"
          className="h-[24px] max-w-[calc(100%-34px)] grow rounded-none !border-none bg-none p-0 !pl-0 pr-6 text-base text-black !outline-none !ring-0"
          placeholder="Search"
          value={val}
          onChange={handleChange}
          onFocus={() => setInputFocused(true)}
          onBlur={() => setInputFocused(false)}
          disabled={isLoading}
        />
        {val !== "" && !isLoading ? (
          <button
            className="absolute right-2 top-1/2 -translate-y-1/2 transform"
            onClick={() => handleChange({ target: { value: "" } })}
          >
            <ActionIcons type="reject" isLoading={false} />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default TableSearch;
